declare const __FRONTEND_VERSION__: string;

export const FRONTEND_VERSION: string =
  typeof __FRONTEND_VERSION__ !== 'undefined' ? __FRONTEND_VERSION__ : '0.0.0';
